import { useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import Home from './pages/Home';
import Properties from './pages/Properties';
import PropertyDetails from './pages/PropertyDetails';
import Services from './pages/Services';
import About from './pages/About';
import Contact from './pages/Contact';
import SocialFeeds from './pages/socialfeed';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant',
    });
  }, [pathname]);

  return null;
};

const App = () => (
  <>
    <ScrollToTop />
    <Routes>
      <Route path="/new-projects" element={<Properties />} />
      <Route path="/new-projects/:developer/:seoSlug" element={<PropertyDetails />} />
      <Route path="/services" element={<Services />} />
      <Route path="/services.html" element={<Services />} />
      <Route path="/about" element={<About />} />
      <Route path="/about.html" element={<About />} />
      <Route path="/contact-us" element={<Contact />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/contact.html" element={<Contact />} />
      <Route path="/properties" element={<Properties />} />
      <Route path="/properties.html" element={<Properties />} />
      <Route path="/social-feeds" element={<SocialFeeds />} />
      <Route path="*" element={<Home />} />
    </Routes>
  </>
);

export default App;
